import React from "react";

export const triggerToastBar = () => {
  const el = document.getElementById("toastbar");

  if (!el) {
    return;
  }

  el.className += " toastbar--show";
  setTimeout(function () {
    el.className = el.className.replace("toastbar--show", "");
  }, 3000);
};

const ToastBar = ({ children }) => {
  return (
    <div id="toastbar" className="toastbar">
      {children}
      <style jsx>{`
        .toastbar {
          visibility: hidden;
          min-width: 250px;
          margin-left: -125px;
          background-color: #333;
          color: #fff;
          text-align: center;
          border-radius: 2px;
          padding: 8px;
          position: fixed;
          z-index: 1;
          left: 50%;
          bottom: 30px;
          font-size: 17px;
          border-radius: 8px;
        }

        .toastbar--show {
          visibility: visible;
          -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
          animation: fadein 0.5s, fadeout 0.5s 2.5s;
        }

        @-webkit-keyframes fadein {
          from {
            bottom: 0;
            opacity: 0;
          }
          to {
            bottom: 30px;
            opacity: 1;
          }
        }

        @keyframes fadein {
          from {
            bottom: 0;
            opacity: 0;
          }
          to {
            bottom: 30px;
            opacity: 1;
          }
        }

        @-webkit-keyframes fadeout {
          from {
            bottom: 30px;
            opacity: 1;
          }
          to {
            bottom: 0;
            opacity: 0;
          }
        }

        @keyframes fadeout {
          from {
            bottom: 30px;
            opacity: 1;
          }
          to {
            bottom: 0;
            opacity: 0;
          }
        }
        @media only screen and (max-width: 600px) {
          .toastbar {
            font-size: 12px;
          }
        }
      `}</style>
    </div>
  );
};

export default ToastBar;
